export const ALIYUN_CAPTCHA_SCENE_ID = '1obfz1o2';
export const ALIYUN_CAPTCHA_PREFIX = '2aiskc';
const sdkUrl = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';

export type AliyunCaptchaInstance = { show?: () => void; hide?: () => void; destroy?: () => void };
export type AliyunCaptchaResult = { captchaResult: boolean; bizResult?: string | boolean };

declare global {
  interface Window {
    AliyunCaptchaConfig?: { region: 'cn' | 'sgp'; prefix: string };
    initAliyunCaptcha?: (options: Record<string, unknown>) => void;
  }
}

let sdkPromise: Promise<void> | null = null;

export function loadAliyunCaptcha() {
  if (typeof window === 'undefined') return Promise.reject(new Error('验证码只能在浏览器中运行。'));
  if (window.initAliyunCaptcha) return Promise.resolve();
  if (sdkPromise) return sdkPromise;
  window.AliyunCaptchaConfig = { region: 'cn', prefix: ALIYUN_CAPTCHA_PREFIX };
  sdkPromise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${sdkUrl}"]`);
    const script = existing || document.createElement('script');
    const loaded = () => window.initAliyunCaptcha ? resolve() : reject(new Error('阿里云验证码初始化函数不可用。'));
    script.addEventListener('load', loaded, { once: true });
    script.addEventListener('error', () => reject(new Error('阿里云验证码资源加载失败。')), { once: true });
    if (!existing) { script.src = sdkUrl; script.async = true; document.head.appendChild(script); }
  });
  return sdkPromise;
}
